<!-- This should have all the header and nav elements-->
@if (securityContextService.loggedIn$ | async) {
  <header id="header"></header>
  <sidebar id="menu"></sidebar>
}

<!-- The routed views render in the <router-outlet>-->
<div id="wrapper">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>

@if (
  (isFirstLoad && securityContextService.isLoggedIn()) || (loading$ | async)
) {
  <div class="loader" [ngClass]="{ 'full-blur': isFirstLoad }">
    <div class="spinner-wrapper">
      <div class="spinner">
        <img src="assets/images/loading-bars.svg" width="128" height="64" />
      </div>
    </div>
  </div>
}

<router-outlet name="modal"></router-outlet>
